// extracted by mini-css-extract-plugin
export default {"cls1":"CreateSocialItemModal-cls1__f3be5df5de840fbcc7c0","cls2":"CreateSocialItemModal-cls2___f28776576361cfc83b3 CreateSocialItemModal-cls1__f3be5df5de840fbcc7c0"};